import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';

import {FuseConfigService} from '@fuse/services/config.service';
import {fuseAnimations} from '@fuse/animations';

import {AuthService} from '@app/services/auth/auth.service';

import {Store} from '@ngrx/store';
import {LogIn, SecretKeyLogin, ToggleInLoggingScreen, TokenLogin} from '@store/actions/auth.actions';
import {combineLatest, Observable, Subscription} from 'rxjs';
import {AppState, selectAuthState} from '@store/app.states';
import {ActivatedRoute, Params} from '@angular/router';
import {map} from 'rxjs/operators';

@Component({
    selector: 'login-2',
    templateUrl: './login-2.component.html',
    styleUrls: ['./login-2.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    standalone: false
})
export class Login2Component implements OnInit, OnDestroy {
  loginForm: UntypedFormGroup;
  getState$: Observable<any> = this.store.select(selectAuthState);
  private route$: Subscription;

  token: string = null;

  /**
   * Constructor
   *
   * @param {FuseConfigService} _fuseConfigService
   * @param {FormBuilder} _formBuilder
   */
  constructor(
    private _fuseConfigService: FuseConfigService,
    private _formBuilder: UntypedFormBuilder,
    private store: Store<AppState>,
    private route: ActivatedRoute,
  ) {

    this.store.dispatch(new ToggleInLoggingScreen({value: true}));

    //

    //
    // Configure the layout
    this._fuseConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        toolbar: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        sidepanel: {
          hidden: true,
        },
      },
    };
    //
    //

    this.route$ = combineLatest(this.route.params, this.route.queryParams)
      .pipe(
        // Merge params from angularRouteKey & url params
        map(([params, queryParams]) => ({...params, ...queryParams})),
      )
      .subscribe((allParams) => {
        //
        // Éventuellement on peut ajouter un &route=quelque/chose à l'url pour une redirection
        // console.log(allParams);
        //
        let gotoRoute = null;
        if (allParams.gotoRoute) {
          gotoRoute = allParams.gotoRoute;
        }
        let iframeFromLegacy = false;
        if (allParams.iframeFromLegacy) {
          iframeFromLegacy = allParams.iframeFromLegacy === 'true';
        }

        //
        // Login via a JWT Token
        //
        if (allParams.token) {
          // this.surveyId = +params.surveyId; // cast to number
          this.token = allParams.token;
          // console.log('Login Component Token:', allParams.token);
          this.store.dispatch(new TokenLogin({token: allParams.token, gotoRoute, iframeFromLegacy}));
        } else {
          // console.log('No token');
        }

        //
        // Login via a secret Key (annotators)
        //
        if (allParams.secretKey) {
          // this.surveyId = +params.surveyId; // cast to number
          this.token = allParams.secretKey;
          // console.log('Login Component With secret Key:', allParams.secretKey);
          this.store.dispatch(new SecretKeyLogin({secretKey: allParams.secretKey, gotoRoute}));
        } else {
          // console.log('No secret token');
        }

      });
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this.loginForm = this._formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
    });
  }

  onSubmit(): void {

    this.store.dispatch(new LogIn(this.loginForm.value));

  }

  ngOnDestroy(): void {

    this.store.dispatch(new ToggleInLoggingScreen({value: false}));

  }
}
